module.exports = __webpack_public_path__ + "img/title-mobile.c91c1819.png";